'use strict';

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumericKey = exports.isSpecialKey = exports.isEscapeKey = exports.Key = void 0;
var Key;
(function (Key) {
    Key[Key["ESCAPE"] = 0] = "ESCAPE";
    Key[Key["ARROW_DOWN"] = 1] = "ARROW_DOWN";
    Key[Key["ARROW_UP"] = 2] = "ARROW_UP";
    Key[Key["ARROW_LEFT"] = 3] = "ARROW_LEFT";
    Key[Key["ARROW_RIGHT"] = 4] = "ARROW_RIGHT";
    Key[Key["TAB"] = 5] = "TAB";
    Key[Key["CONTROL"] = 6] = "CONTROL";
    Key[Key["SHIFT"] = 7] = "SHIFT";
    Key[Key["META"] = 8] = "META";
    Key[Key["DELETE"] = 9] = "DELETE";
    Key[Key["BACKSPACE"] = 10] = "BACKSPACE";
    Key[Key["UNIDENTIFIED"] = 11] = "UNIDENTIFIED";
})(Key = exports.Key || (exports.Key = {}));
var SpecialKeys = (_a = {},
    _a[Key.ESCAPE] = ['Esc', 'Escape', 27],
    _a[Key.ARROW_DOWN] = ['Down', 'ArrowDown', 40],
    _a[Key.ARROW_UP] = ['Up', 'ArrowUp', 38],
    _a[Key.ARROW_LEFT] = ['Left', 'ArrowLeft', 37],
    _a[Key.ARROW_RIGHT] = ['Right', 'ArrowRight', 39],
    _a[Key.TAB] = ['Tab', 9],
    _a[Key.CONTROL] = ['Control', 17],
    _a[Key.SHIFT] = ['Shift', 16],
    _a[Key.META] = ['Win', 'Meta', 91],
    _a[Key.BACKSPACE] = ['Backspace', 8],
    _a[Key.DELETE] = ['Delete', 46],
    // Unidentified 'unknown' key. Fired on Android browsers.
    _a[Key.UNIDENTIFIED] = ['Unidentified', 229],
    _a);
var AllSpecialKeys = Object.values(SpecialKeys).reduce(function (curr, prev) { return curr.concat.apply(curr, prev); }, []);
// prettier-ignore
var NumberKeys = [
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    // Key Codes
    48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
];
function isEscapeKey(event) {
    return SpecialKeys[Key.ESCAPE].includes(event.key || event.keyCode);
}
exports.isEscapeKey = isEscapeKey;
function isSpecialKey(event) {
    return AllSpecialKeys.includes(event.key || event.keyCode);
}
exports.isSpecialKey = isSpecialKey;
function isNumericKey(event) {
    return NumberKeys.includes(event.key || event.keyCode);
}
exports.isNumericKey = isNumericKey;
